module.exports = __webpack_public_path__ + "media/images/landing-pages/sec-hero-d487883b3fef73e24dbd513c8b0901af.png";